/**
 * Ryan O'Dowd
 * 2022-08-28
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Icon from '@react-native-vector-icons/material-design-icons';
import React from 'react';
import Text from '@components/common/Text';
import {
  TouchableOpacity,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const Tag = (props: TagProps) => {
  const styles = hooks.useStyles(getStyles);

  // @TODO: on tap, search for other goals with this tag
  return (
    <TouchableOpacity
      style={styles.container}
      onPress={() => props.onPress(props.name)}
    >
      <Icon style={styles.leftTagIcon} name='tag' />
      <Text style={styles.tagText}>{props.name.toUpperCase()}</Text>
      {props.isDeletable && <Icon style={styles.rightTagIcon} name='close' />}
    </TouchableOpacity>
  );
};

class TagProps {
  name: string;
  onPress: (name: string) => void;

  isDeletable?: boolean;
};

export default Tag;
